import { createGqlSubscriptionApi } from '@main/graphql/create-subscription-api';

import { api, GetVendorQuestionnairesTableDocument } from './questionnaires-table.vendor.generated';

export const { useGetVendorQuestionnairesTableQuery: useGetVendorQuestionnairesTableSubscription } =
  createGqlSubscriptionApi(
    api,
    'GetVendorQuestionnairesTable',
    GetVendorQuestionnairesTableDocument,
  );
